abstract class DOM {
  protected htmlStr: string
  protected dom: any
  protected id: string
  public abstract getHTMLStr(): string
}

export default DOM
